import { useEffect,useState } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Pagination from '../Common/Pagination';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';

const List = () => {

    const [branchId,setBranchId] = useState('');
    const [branches,setBranches] = useState([]);
    const {readData: getBranchesData} = useEntityCrud('Branch/GetAllBranchs');
    const [nationalCode,setNationalCode] = useState('');
    const [childNationalCode,setChildNationalCode] = useState('');
    const [childMobile,setChildMobile] = useState('');
    const [status,setStatus] = useState('');
    const {readData: getChildren} = useEntityCrud('User/getDependentPeople');
    const [children,setChildren] = useState(null);
    const [pages,setPages] = useState([]);
    const [currentPage,setCurrentPage] = useState(1);
    const [lastPage,setLastPage] = useState(0);

    useEffect(() => {
        const postedData = {
            offset: 0,
            limit: 1000
        }
        getBranchesData(postedData).then(({data}) => {
            if(data.status){
                const result = data.result.map(i => ({label: i.title, value: i.id}));
                setBranches(result);
            }
        })
    },[])

    const findChildren = excel => {
        const postedData = {
            offset: 0,
            limit: 10
        };
        if(branchId)
            postedData.companyId = branchId.toString();
        if(nationalCode)
            postedData.mainPersonNationalCode = nationalCode;
        if(childNationalCode)
            postedData.dependentNationalCode = childNationalCode;
        if(childMobile)
            postedData.dependentMobile = childMobile;
        if(status)
            postedData.status = status;
        if(excel)
            postedData.excelOutput = true;
        else
            postedData.excelOutput = false;
        getChildren(postedData).then(({data}) => {
            if(excel){
                window.open(data.excelPath);
            }else{
                if(data.status && data.result && data.result.isSuccess){
                    setChildren(data.result.data);
                    calcPages(data)
                }else
                    setChildren([]);
            }
        })
    }

    const calcPages = res => {
        let calcPages = res.count / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            limit: 10,
            offset: page - 1
        };
        if(branchId)
            postedData.companyId = branchId.toString();
        if(nationalCode)
            postedData.mainPersonNationalCode = nationalCode;
        if(childNationalCode)
            postedData.dependentNationalCode = childNationalCode;
        if(childMobile)
            postedData.dependentMobile = childMobile;
        if(status)
            postedData.status = status;
        getChildren(postedData).then(({data}) => {
            if(data.status && data.result && data.result.isSuccess)
                setChildren(data.result.data);
            else
                setChildren([]);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };
        if(branchId)
            postedData.companyId = branchId.toString();
        if(nationalCode)
            postedData.mainPersonNationalCode = nationalCode;
        if(childNationalCode)
            postedData.dependentNationalCode = childNationalCode;
        if(childMobile)
            postedData.dependentMobile = childMobile;
        if(status)
            postedData.status = status;
        getChildren(postedData).then(({data}) => {
            if(data.status && data.result && data.result.isSuccess)
                setChildren(data.result.data);
            else
                setChildren([]);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            limit: 10,
            offset: currentPage
        };
        if(branchId)
            postedData.companyId = branchId.toString();
        if(nationalCode)
            postedData.mainPersonNationalCode = nationalCode;
        if(childNationalCode)
            postedData.dependentNationalCode = childNationalCode;
        if(childMobile)
            postedData.dependentMobile = childMobile;
        if(status)
            postedData.status = status;
        getChildren(postedData).then(({data}) => {
            if(data.status && data.result && data.result.isSuccess)
                setChildren(data.result.data);
            else
                setChildren([]);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">لیست فرزندان ثبت شده</div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>شرکت</label>
                            <ReactSelect noOptionsMessage={(e) => "یافت نشد"} placeholder="انتخاب کنید" options={branches} value={branches.filter((b) => b.value == branchId)} onChange={(e) => setBranchId(e.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی والد</label>
                            <input type="tel" className="form-control ltr-input" value={nationalCode} onChange={e => setNationalCode(e.target.value)} maxLength={10} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی فرزند</label>
                            <input type="tel" className="form-control ltr-input" value={childNationalCode} onChange={e => setChildNationalCode(e.target.value)} maxLength={10} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>شماره همراه فرزند</label>
                            <input type="tel" className="form-control ltr-input" value={childMobile} onChange={e => setChildMobile(e.target.value)} maxLength={11} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>وضعیت</label>
                            <select className="form-control" onChange={e => setStatus(e.target.value)}>
                                <option>انتخاب کنید</option>
                                <option value="2">در انتظار</option>
                                <option value="1">تایید شده</option>
                                <option value="0">تایید نشده</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <button className="btn btn-primary me-2" onClick={() => findChildren(false)} disabled={!branchId && !nationalCode && !childNationalCode && !childMobile}>جستجو</button>
                        {children !== null && children.length ? <button className="btn btn-success" onClick={() => findChildren(true)}>دریافت خروجی اکسل</button> : ''}
                    </div>
                </div>
                {children !== null && children.length ? <hr /> : ''}
                {children !== null && children.length ? <div className="table-responsive">
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>نام و نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>شماره همراه</th>
                                <th>کد ملی والد</th>
                                <th>نسبت</th>
                                <th>شرکت</th>
                                <th>تاریخ ثبت</th>
                                <th>وضعیت</th>
                                <th>دفعات استعلام</th>
                            </tr>
                        </thead>
                        <tbody>
                            {children.map((child,index) => <tr key={index}>
                                <td>{(index + 1) + (currentPage > 1 ? (currentPage - 1) * 10 : '')}</td>
                                <td>{child.dependentname + ' ' + child.dependentfamily}</td>
                                <td>{child.dependentnationalcode}</td>
                                <td>{child.dependentmobile}</td>
                                <td>{child.mainpersonnationalcode}</td>
                                <td>{child.relationship}</td>
                                <td>{child.companyname}</td>
                                <td>{new Date(child.insertdate.split('T')[0]).toLocaleDateString('fa-IR')}</td>
                                {child.isshahkar === null ? <td>در انتظار</td> : (child.isshahkar ? <td className="text-success">تایید شده</td> : <td className="text-danger">تایید نشده</td>)}
                                <td>{child.cunterShahkar || 0}</td>
                            </tr>)}
                        </tbody>
                    </table>
                    <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                </div> : (children !== null ? <div className="alert alert-info"><p className="mb-0">داده ای یافت نشد</p></div> : '')}
            </div>
        </div>
    )
}

export default List